module.exports = __webpack_public_path__ + "media/images/athletes/4346-1571900bc2ccaa7bd4c1c5034e9454e0.png";